import type { FC } from 'react';

const Loading: FC = () => <p>Loading</p>;

export default Loading;
